import { defaultHeaders } from './default-headers';

type InitLogoutResponse = {
  logout_url: string;
};

export async function logout(baseUrl: string, returnTo?: string): Promise<void> {
  const initLogoutUrl = returnTo
    ? `${baseUrl}/self-service/logout/browser?return_to=${encodeURIComponent(returnTo)}`
    : `${baseUrl}/self-service/logout/browser`;

  const options: RequestInit = {
    method: 'GET',
    headers: defaultHeaders,
    credentials: 'include',
  };

  const logoutUrlResponse: InitLogoutResponse = await fetch(initLogoutUrl, options)
    .then((res) => res.json())
    .then((data) => data);

  const logoutUrl = logoutUrlResponse?.logout_url;

  if (!logoutUrl) {
    throw new Error('failed to initiate user logout');
  }

  const parsedLogoutUrl = new URL(logoutUrl);
  const params = new URLSearchParams(parsedLogoutUrl.search);
  params.set('return_to', `${returnTo}`);

  parsedLogoutUrl.search = params.toString();

  window.location.href = parsedLogoutUrl.toString();
}
